import { WORD_SPACINGS } from '../config/settings';
import { setCssVar, removeCssVar } from '../utils/domHelpers';
import { CSS_VARS } from '../utils/constants';

export function applyWordSpacing(index) {
  if (index >= 0 && index < WORD_SPACINGS.length) {
    const val = WORD_SPACINGS[index].value;
    if (val) {
      setCssVar(CSS_VARS.wordSpacing, val);
    } else {
      removeCssVar(CSS_VARS.wordSpacing);
    }
  }
}

export function removeWordSpacing() {
  removeCssVar(CSS_VARS.wordSpacing);
}
